
import Vue from "vue";
import { Component } from "vue-property-decorator";
import LoadingSpinner from "@/components/Reusable/LoadingSpinner.vue";

@Component({
  components: { LoadingSpinner }
})
export default class Loading extends Vue {
  show = true;
}
